<template>
    <div class="book-detail">
        <p class="title">{{ cell.title }}</p>
        <p class="date">{{ cell.createTime }}</p>
        <div class="content">

            <template v-if="cell.imageUrl">
                <div class="img-wrap">
                    <img :src="cell.imageUrl"/>
                </div>
            </template>
            <template v-else>
                <el-carousel :interval="4000" type="card" class="carousel-img" height="200px" >
                    <el-carousel-item v-for="item in cell.imageUrlList">
                        <div style="text-align: center;">
                            <img style="max-height: 200px" :src="item.imageUrl">
                        </div>
                    </el-carousel-item>
                </el-carousel>
            </template>
            <p v-html="cell.content" class="quil-content ql-snow ql-editor">
            </p>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            cell: {
                type: Object,
                default: () => {
                    return {}
                }
            },
        }
    };
</script>
<style lang="less" scoped>
    .book-detail {
        width: 80%;
        margin: 0 auto;

        .title {
            font-size: 24px;
        }

        .date {
            font-size: 14px;
            margin: 12px 0;
        }

        .content {
            padding-top: 20px;

            .img-wrap {
                display: flex;
                margin: 28px 0;
                justify-content: center;

                img {
                    max-height: 300px;
                }
            }

            border-top: 1px solid;
            .quil-content {
                /deep/ img {
                    width: 100%;
                    height: 100%;
                    object-fit: fill;
                }
            }
        }
    }
     .carousel-img{
         width: 50%;
         margin: 0 auto;
     }
</style>
